export default __webpack_public_path__ + "static/media/Alvarez.449834bc.jpg";